import React, { useState, useEffect, useContext } from "react";
import "../css/style.css";
import "../css/login1.css";
import { NavLink } from "react-router-dom";
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import OtpInput from "react-otp-input";
import { subApi } from "../../services/user-api";
import {
  serviceId,
  Loader,
  countryCode,
  flag,
  Random,
  customStyles,
  serviceName,
} from "../../utils/constant";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { LanguageContext } from "../LanguageContext";

const Ogb = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [flowLoading, setFlowLoading] = useState(false);
  const [alreadySub, setAlreadySub] = useState(false);
  const [phone, setPhone] = useState(
    localStorage.getItem("ugAlias") ? localStorage.getItem("ugAlias") : "",
  );
  const [flow, setFlow] = useState("");
  const [subType, setSubType] = useState(1);
  const [plan, setPlan] = useState(1);

  const [price] = useState([0, 60, 350, 60, 350]);
  const [message, setMessage] = useState({ message: "", error: false });
  const [otpId, setOtpId] = useState("");
  const [otp, setOtp] = useState("");
  const [otpArr, setOtpArr] = useState([]);
  const [ButtonDisabled, setButtonDisabled] = useState(true);
  const { t } = useTranslation("global");
  const [q] = useSearchParams();
  const [uniqueId, setUniqueId] = useState("");
  const [subMode, setSubMode] = useState("WAP");

  useEffect(() => {
    if (q.get("uid")) {
      setUniqueId(q.get("uid"));
      setSubMode("APP");
      console.log("phone=" + phone + ":" + uniqueId);
    } else {
      setUniqueId(Random());
      console.log("phone=" + phone + "::" + uniqueId);
    }
    if (phone) {
      if (q.get("uid")) // Promotion flow
      {
        var nm = phone;
        if (nm.length < 10) nm = countryCode + nm;
        subApi({
          action: 3,
          serviceId: serviceId,
          ani: nm,
          mode: subMode,
          uid: uniqueId,
        })
          .then((res) => {
            if (res.status === 200) {
              if (res.data.responseCode === 202) // already subscribed
              {
                localStorage.setItem("token", res.data.data.accessToken);
                window.location.href = "/home";
                //setAlreadySub(true);setFlow("SUCCESS");
              } else {
                if (res.data.data) // set otp auto fill for promotion
                {
                  const str = String(res.data.data);
                  let strArr = [];
                  for (let i = 0; i < str.length; i++) {
                    strArr[i] = Number(str[i]);
                  }
                  setOtpArr(strArr);
                  setButtonDisabled(false);
                }
                setFlow("OTPCONFIRM");
              }
            } else {
              setMessage({ message: res.data.message, error: true });
            }
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setMessage({ message: err.message, error: true });
            setLoading(false);
          });
      } else {
        subApi({ action: 0, ani: phone, serviceId: serviceId })
          .then((res) => {
            console.log(res);
            if (res.data.data !== null && res.data.data !== undefined) {
              setFlowLoading(false);
              localStorage.setItem("token", res.data.data.accessToken);
              window.location.href = "/home";
            } else {
              setFlowLoading(false);
              setFlow("");
              setButtonDisabled(false);
            }
          })
          .catch((err) => {
            console.log(err);
            setFlowLoading(false);
            setFlow("");
            setButtonDisabled(false);
          });
      }
    }
  }, []);

  const handleButtonClick = async () => {
    //console.log(phone);
    setLoading(true);
    await subApi({
      action: 1,
      serviceId: serviceId,
      planId: plan,
      ani: phone,
      mode: subMode,
      uid: uniqueId,
    })
      .then((res) => {
        console.log(res);
        localStorage.setItem("token", res.data.data.accessToken);
        setFlow("SUCCESS");
      })
      .catch((err) => {
        console.log(err);
        if (err.message === "Not enough balance")
          setMessage({ message: "NoBalance", error: true });
        else setMessage({ message: "SomethingWrong", error: true });
      })
      .finally(() => setLoading(false));
  };

  const sendOtp = async () => {
    console.log("phone=" + phone);
    setMessage({ message: "", error: false });
    if (phone && phone.length >= 8) {
      var nm = phone;
      if (nm.length <= 10) nm = countryCode + nm;
      setLoading(true);
      await subApi({
        action: 3,
        serviceId: serviceId,
        ani: nm,
        mode: subMode,
        uid: uniqueId,
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.responseCode === 202) // already subscribed
            {
              localStorage.setItem("token", res.data.data.accessToken);
              window.location.href = "/home";
              //setAlreadySub(true);setFlow("SUCCESS");
            } else {
              if (res?.data?.data) {
                setOtp("" + res.data.data);
                const str = String(res.data.data);
                let strArr = [];
                for (let i = 0; i < str.length; i++) {
                  strArr[i] = Number(str[i]);
                }
                setOtpArr(strArr);
                setButtonDisabled(false);
                setFlow("OTPCONFIRM");
              } else setFlow("OTPCONFIRM");
            }
          } else {
            setMessage({ message: res.data.message, error: true });
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setMessage({ message: err.message, error: true });
          setLoading(false);
        });
    } else if (phone && phone.length > 0) {
      setMessage({ message: t("portalText.Msg Valid Number"), error: true });
    } else {
      setMessage({ message: t("portalText.Msg Number"), error: true });
    }

    // navigate('/profile');
  };

  const confirmOtp = async () => {
    setMessage({ message: "", error: false });
    if (otp != null && otp.length === 4) {
      console.log("Enter");
      var nm = phone;
      if (nm.length <= 8) nm = countryCode + nm;
      setLoading(true);
      await subApi({
        action: 4,
        serviceId: serviceId,
        ani: nm,
        otpId: otpId,
        otp: otp,
        mode: subMode,
        uid: uniqueId,
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.responseCode === 202) // already subscribed
            {
              localStorage.setItem("token", res.data.data.accessToken);
              window.location.href = "/home";
              //setAlreadySub(true);setFlow("SUCCESS");
            } else {
              localStorage.setItem("ugAlias", nm);
              if (subMode === "APP") {
                setPlan(1);
                setFlow("DOUBLECONFIRM");
              } else setFlow("PACK");
            }
          } else {
            setMessage({ message: res.data.message, error: true });
          }
        })
        .catch((err) => {
          setMessage({ message: err.message, error: true });
        })
        .finally(() => setLoading(false));
    } else {
      setMessage({ message: t("portalText.Msg Valid OTP"), error: true });
    }
  };

  const handleNumberChange = async (event) => {
    const input = event.target.value;
    if (input.length < 11) setPhone(input);
    setButtonDisabled(input.length < 8);
  };
  const handleRadioChange = async (input) => {
    setPlan(input);
  };

  const cancel = async (input) => {
    setMessage({ message: "", error: false });
    setFlow(input);
  };
  const handleNumInputsChange = (numInputs) => {
    setOtp(numInputs);
    setButtonDisabled(numInputs.length !== 4 || isNaN(numInputs));
  };
  const handleSubType = (input) => {
    setSubType(input);
    if (input === 1) setPlan(1);
    else setPlan(3);
  };
  const redirectTo = async (input) => {
    if (input === "/home") window.location.href = "/home";
    else navigate(input);
  };

  // Language option //
  const { language, changeLanguage } = useContext(LanguageContext);
  const languages = [
    { value: "pr", label: "Portuguese" },
    { value: "en", label: "English" },
  ];
  const selectedOption = languages.find((option) => option.value === language);
  const handleChange = (selectedOption) => {
    changeLanguage(selectedOption.value);
  };

  return flowLoading ? (
    <Loader />
  ) : (
    <>
      <div className="home">
        <div className="maine-div">
          <div className="container-fluid box-wrapper login">
            <div className="pt-5">
              <div className="row align-items-center">
                <div className="col-4"></div>
                <div className="col-4">
                  <div className="logo d-flex">
                    {/* <img src="/images/uv_games_logo.png" alt="UVGames" /> */}
                  </div>
                </div>

                <div className="col-4">
                  <div className="pt-2">
                    <Select
                      menuPlacement="top"
                      value={selectedOption}
                      options={languages}
                      onChange={handleChange}
                      styles={customStyles}
                      placeholder="Select Language"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="login-header pb-4">
              <div className="box-wrapper mx-auto text-center position-relative">
                <span className="modal-level-title game-title">
                  {t("portalText.ogbDesc")}
                </span>
                <img className="ogMoney" src="/images/ogg.png" alt="UVGames" />
                <span className="modal-level-title game-title">
                  {t("portalText.ogbDesc1")}
                </span>
              </div>
            </div>
            <div className="login-info">
              <div className="login-thumbnail2">
                <img src="/images/login_img.png" alt="UVGames" />
              </div>

              {flow === "PACK" ? (
                <>
                  <h3 className="header-title-green mb-3 mt-3 text-center">
                    {t("portalText.Sub Plan")}
                  </h3>
                  <div className="text-center radio">
                    <label>
                      <input
                        type="radio"
                        id="rd1"
                        value={subType === 1 ? 1 : 3}
                        checked={plan === 1 || plan === 3}
                        onChange={() => setPlan(subType === 1 ? 1 : 3)}
                      />
                      60 FCFA/{t("portalText.Day")}
                    </label>
                    <label>
                      <input
                        type="radio"
                        id="rd2"
                        value={subType === 1 ? 2 : 4}
                        checked={plan === 2 || plan === 4}
                        onChange={() => setPlan(subType === 1 ? 2 : 4)}
                      />
                      350 FCFA/{t("portalText.Week")}
                    </label>
                  </div>
                  <div className="text-center phone-info">
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {message.message}
                        </p>{" "}
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="btn btn-primary btn-pm-custom"
                        type="button"
                        onClick={() => setFlow("DOUBLECONFIRM")}
                      >
                        {t("portalText.countinue")}
                      </button>
                    )}
                  </div>
                </>
              ) : flow === "OTPCONFIRM" ? (
                <>
                  <h3 className="login-title mb-3 mt-3 text-center">
                    {t("portalText.Enter OTP")}
                  </h3>
                  <div className="phone-info">
                    <div className="otp_section">
                      <OtpInput
                        value={otp}
                        numInputs={4}
                        renderInput={(props, index) => (
                          <input
                            {...props}
                            type="tel"
                            inputMode="numeric"
                            value={otpArr ? otpArr[index] : ""}
                          />
                        )}
                        inputStyle="form-control form-otp"
                        onChange={handleNumInputsChange}
                      />
                    </div>
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {message.message}
                        </p>{" "}
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="btn btn-primary btn-pm-custom"
                        type="button"
                        onClick={confirmOtp}
                        disabled={ButtonDisabled}
                      >
                        {t("portalText.Confirm")}
                      </button>
                    )}
                    <div className="resend_otp">
                      <a
                        className="send_otp_link"
                        onClick={() => {
                          cancel("");
                        }}
                      >
                        {" "}
                        &lt;&lt;&nbsp;{t("portalText.Back")}
                      </a>
                    </div>
                  </div>
                </>
              ) : flow === "DOUBLECONFIRM" ? (
                <>
                  <h3 className="login-title mb-3 mt-3 text-center">
                    {t("portalText.confirm_pack_" + plan)}
                  </h3>
                  <h3 className="login-title mb-3 mt-3 text-center">
                    {t("portalText.doubleConfirm2")}
                  </h3>
                  {message.message && (
                    <div className="mb-3">
                      <p
                        className={`alert alert-${message.error ? "danger" : "success"}`}
                      >
                        {t("portalText." + message.message)}
                      </p>{" "}
                    </div>
                  )}
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      <button
                        className="btn btn-primary btn-pm-green"
                        type="button"
                        onClick={handleButtonClick}
                      >
                        {t("portalText.YES")}
                      </button>
                      <button
                        className="btn btn-primary btn-pm-red"
                        type="button"
                        onClick={() => setFlow("")}
                      >
                        {t("portalText.NO")}
                      </button>
                    </>
                  )}
                </>
              ) : flow === "SUCCESS" ? (
                <>
                  {alreadySub ? (
                    <h3 className="login-title-green mb-3 mt-3 text-center">
                      {subType === 1
                        ? t("portalText.AlreadySub")
                        : t("portalText.AlreadySubOneTime")}
                    </h3>
                  ) : (
                    <>
                      <h3 className="login-title-green mt-3 text-center">
                        {subType === 1
                          ? t("portalText.SubSuccess")
                          : t("portalText.SubSuccessOneTime")}
                      </h3>
                      <h3 className="login-title-red text-center">
                        {"[ " +
                          price[plan] +
                          " FCFA/" +
                          (plan === 1 || plan === 3
                            ? t("portalText.Day")
                            : t("portalText.Week")) +
                          " ]"}
                      </h3>
                    </>
                  )}
                  <h3 className="login-title mb-3 mt-3 text-center">
                    {t("portalText.Access Service")}
                  </h3>
                  {loading ? (
                    <Loader />
                  ) : (
                    <button
                      className="btn btn-primary btn-pm-custom"
                      type="button"
                      onClick={() => {
                        redirectTo("/home");
                      }}
                    >
                      {t("portalText.Click Here")}
                    </button>
                  )}
                </>
              ) : (
                <>
                  <h3 className="login-title mt-3 text-center">
                    {t("portalText.Welcome") + serviceName}
                  </h3>
                  {/* <h3 className="login-title mb-3 mt-3 text-center">
                    {t("portalText.ogbWelcome")}
                  </h3> */}

                  <div className="phone-input">
                    <div className="has-validation input-group">
                      <div className="dialing-code">
                        <img
                          src={"https://flagcdn.com/" + flag + ".svg"}
                          width="24"
                          alt="Cameroon"
                        />
                        <span>+{countryCode}</span>
                      </div>
                      <input
                        className="form-control form-mobile-no"
                        type="number"
                        inputMode="numeric"
                        value={
                          phone.length > 9
                            ? phone.substring(phone.length - 9)
                            : phone
                        }
                        onChange={handleNumberChange}
                        placeholder={t("portalText.Enter Number")}
                      />
                    </div>
                    <div className="mt-2 text-start">
                      <h3 className="header-title-green p-2 text-start">
                        {t("portalText.subType")}
                      </h3>
                      <div className="text-start radio">
                        <label>
                          <input
                            type="radio"
                            id="rd1"
                            value="1"
                            checked={subType === 1}
                            onChange={() => handleSubType(1)}
                          />
                          {t("portalText.autoRenewal")}
                        </label>
                        <br />
                        <label>
                          <input
                            type="radio"
                            id="rd2"
                            value="2"
                            checked={subType === 2}
                            onChange={() => handleSubType(2)}
                          />
                          {t("portalText.oneTime")}
                        </label>
                      </div>
                    </div>
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {message.message}
                        </p>{" "}
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="btn btn-primary btn-pm-custom"
                        type="button"
                        onClick={sendOtp}
                        disabled={ButtonDisabled}
                      >
                        {t("portalText.Submit")}
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ogb;
